'use client';

import { MsalHelper } from '@/auth/msal/helpers';
import { useContext } from 'react';
import { CommonContext } from '../context/commonContext';

export function LogoutButton() {
  const { disableNavigation, setModalWarningOpen } = useContext(CommonContext);
  return (
    <button
      type="button"
      onClick={e => {
        if (disableNavigation) {
          e.preventDefault();
          setModalWarningOpen(true);
        } else {
          MsalHelper.handleLogout();
        }
      }}
      className="fixed top-4 right-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center"
    >
      <svg
        className="w-5 h-5 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
        />
      </svg>
      Logout
    </button>
  );
}
